import React from 'react';
import { Link } from 'react-router-dom';

function HomePage() {
  return (
    <div className="home-page">
      <div className="hero">
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>
          Volleyball Game Analyzer
        </h1>
        <p style={{ fontSize: '1.25rem', color: '#64748b', marginBottom: '2rem' }}>
          Track player statistics, analyze game footage, and improve team performance
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
          <Link to="/upload" className="btn btn-primary" style={{ fontSize: '1.125rem' }}>
            Upload Video
          </Link>
          <Link to="/matches" className="btn btn-secondary" style={{ fontSize: '1.125rem' }}>
            View Matches
          </Link>
        </div>
      </div>

      <div className="features" style={{ marginTop: '4rem' }}>
        <div className="grid grid-3">
          <div className="card">
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📹</div>
            <h3 className="card-title">Video Analysis</h3>
            <p>Upload game footage or YouTube links. Our AI automatically detects players and tracks their movements throughout the match.</p>
          </div>

          <div className="card">
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✏️</div>
            <h3 className="card-title">Easy Review</h3>
            <p>Review and verify automatically detected events. Quick keyboard shortcuts make marking plays fast and efficient.</p>
          </div>

          <div className="card">
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📊</div>
            <h3 className="card-title">Detailed Stats</h3>
            <p>Generate comprehensive statistics for each player. Track kills, digs, blocks, serves, and more.</p>
          </div>
        </div>
      </div>

      <div className="features" style={{ marginTop: '2rem' }}>
        <div className="card">
          <h2 style={{ marginBottom: '1rem' }}>How It Works</h2>
          <ol style={{ paddingLeft: '2rem', lineHeight: '2' }}>
            <li><strong>Upload:</strong> Upload your game video or provide a YouTube URL</li>
            <li><strong>Setup:</strong> Input player lineups and jersey numbers</li>
            <li><strong>Process:</strong> Our AI analyzes the video and detects players and events</li>
            <li><strong>Review:</strong> Quickly verify and correct any detections</li>
            <li><strong>Analyze:</strong> View comprehensive statistics and export data</li>
          </ol>
        </div>
      </div>

      <div className="features" style={{ marginTop: '2rem' }}>
        <div className="card" style={{ background: '#eff6ff' }}>
          <h2 style={{ marginBottom: '1rem' }}>Perfect for High School & Club Teams</h2>
          <p style={{ marginBottom: '1rem' }}>
            Designed specifically for coaches, parents, and players who want professional-level analytics
            without the professional price tag. Works with any camera angle and video quality.
          </p>
          <ul style={{ paddingLeft: '2rem', lineHeight: '2' }}>
            <li>No expensive equipment needed</li>
            <li>Works with phone cameras and consumer camcorders</li>
            <li>Semi-automated - AI does the heavy lifting, you verify the important plays</li>
            <li>Export stats in standard formats</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
